<template>
    <div>
      <h2 class="font-bold text-gray-700">Registro de cambios de Notas de Crédito</h2>
      <CreditLotesLog />
    </div>
  </template>
  
  <script>
  import CreditLotesLog from "@/components/logs/CreditLotesLog.vue";
  import { useRoute } from "vue-router";
  import { onBeforeMount, onMounted } from "vue";
  import { findSubmoduleIdByDescription } from "@/hisAcces";
  export default {
    name: "CreditLotesLogView",
    components: {
        CreditLotesLog,
    },
    setup() {
      const route = useRoute();
      onBeforeMount(() => {
        if (!findSubmoduleIdByDescription(route.path)) {
          window.location.href = "/login";
        }
      });
  
      onMounted(() => {
        document.title =
          route.meta.title + process.env.VUE_APP_TITLE ||
          process.env.VUE_APP_TITLE;
      });
    },
  };
  </script>
  